import React, { Component, PureComponent } from 'react';
import { MapPoint, MapRange } from 'types';
import memoize from 'memoize-one';

// Components
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline } from 'react-google-maps';
import { createMapRange } from './utils';

function calculatePoint(points, timestamp) {
  if (!timestamp) return points[0];
  const len = points.length;
  let i = len;
  while (i-- && points[i].time > timestamp);
  if (i < 0) i = 0;
  if (i > len - 1) i = len - 1;
  const before = points[i];
  const after = points[Math.min(len - 1, i + 1)];
  if (before === after) return before;
  const percent = (timestamp - before.time) / (after.time - before.time);
  const lat = before.lat + percent * (after.lat - before.lat);
  const lng = before.lng + percent * (after.lng - before.lng);

  return { lat, lng };
}
interface GoogleMapsProps {
  points: MapPoint[];
  bounds: MapRange;
  range?: [number, number];
  selectedIndexes: number[];
}
interface GoogleMapsState {}

class Maps extends PureComponent<GoogleMapsProps, GoogleMapsState> {
  state = {};

  rangePoints = memoize((points, range) => {
    if (range) {
      const rangePoints = points.filter(p => p.time >= range[0] && p.time < range[1]);
      rangePoints.unshift(calculatePoint(points, range[0]));
      rangePoints.push(calculatePoint(points, range[1]));
      return rangePoints;
    }

    return points;
  });

  map: GoogleMap;
  icon = {
    url: '/static/map-point.svg',
    anchor: new google.maps.Point(12, 12)
  };
  componentDidUpdate(prevProps, prevState) {
    const { range } = this.props;
    if (range !== prevProps.range) {
      this.fitBounds();
    }
  }

  fitBounds() {
    if (this.map) {
      const bounds = createMapRange(this.rangePoints(this.props.points, this.props.range), 20);
      const mapBounds = new window.google.maps.LatLngBounds();
      mapBounds.extend({ lat: bounds.lat, lng: bounds.lng });
      mapBounds.extend({
        lat: bounds.lat + bounds.latDelta,
        lng: bounds.lng + bounds.lngDelta
      });
      this.map.fitBounds(mapBounds);
    }
  }

  handleMapRef = (ref: GoogleMap) => {
    this.map = ref;
    if (ref) {
      window.m = this.map;
    }
    this.fitBounds();
  };

  render() {
    const { points, range, timestamp } = this.props;
    if (!points) return false;
    const rangePoints = this.rangePoints(points, range);

    return (
      <GoogleMap
        ref={this.handleMapRef}
        defaultZoom={14}
        options={{
          mapTypeId: 'satellite',
          gestureHandling: 'greedy',
          streetViewControl: false,
          fullscreenControl: false
        }}
      >
        {points.length > 0 && (
          <Polyline
            path={points}
            options={{
              strokeColor: '#999',
              strokeWidth: 20
            }}
          />
        )}
        {rangePoints.length > 0 && (
          <Polyline
            path={rangePoints}
            options={{
              strokeColor: '#ff5722',
              strokeWidth: 2
            }}
          />
        )}
        <Marker position={calculatePoint(points, timestamp)} icon={this.icon} />;
      </GoogleMap>
    );
  }
}

const WrappedMap = withScriptjs(withGoogleMap(Maps));

export default function Map(props: GoogleMapsProps) {
  return (
    <WrappedMap
      {...props}
      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDuWAc5ueLP0hZjz24FxJ-ANFjvMzVyKhc"
      loadingElement={<div style={{ height: '100%' }} />}
      containerElement={<div style={{ height: '100%', overflow: 'hidden', flex: '1' }} />}
      mapElement={<div style={{ height: '100%' }} />}
    />
  );
}
